import { Owner } from '@/models/owner'
import { NemesisManager } from '@/services/nemesisOwnerManager'

const OWNER_FIRST_NAMES = [
    'John', 'Emma', 'Liam', 'Olivia', 'Noah', 'Ava', 'William', 'Sophia', 'James',
    'Isabella', 'Oliver', 'Charlotte', 'Benjamin', 'Mia', 'Elijah', 'Luna', 'Lucas',
    'Esther', 'Olivia', 'Tifa', 'Palmer', 'Rufus', 'Bugen', 'Sam', 'Chocobo'
]
  
const OWNER_LAST_NAMES = [
    'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Wallace', 'Davis',
    'Rodriguez', 'Martinez', 'Hernandez', 'Lockhart', 'Gonzalez', 'Sam', 'Anderson'
]
  
const RANCH_PREFIXES = [
    'Golden', 'Silver', 'Crystal', 'Ruby', 'Emerald', 'Sapphire', 'Diamond',
    'Feather', 'Darting', 'Claw', 'Wing', 'Titan', 'Ifrit', 'Shiva',
    'Ramuh', 'Odin', 'Mythril', 'Seafoam', 'Dusty', 'Ultimate', 'Meteor',
    'Peaceful', 'Sunny', 'Moonlight', 'Starlight', 'Thunder', 'Lightning', 'Shadow'
]
  
const RANCH_SUFFIXES = [
    'Ranch', 'Stables', 'Fields', 'Meadows', 'Plains', 'Valley', 'Hills',
    'Gardens', 'Pastures', 'Acres', 'Farms', 'Haven', 'Sanctuary', 'Estate'
]
  
export class OwnerFactory {
    static generateRandomOwner() {
      const firstName = OWNER_FIRST_NAMES[Math.floor(Math.random() * OWNER_FIRST_NAMES.length)]
      const lastName = OWNER_LAST_NAMES[Math.floor(Math.random() * OWNER_LAST_NAMES.length)]
      const fullName = `${firstName} ${lastName}`
      
      const ranchPrefix = RANCH_PREFIXES[Math.floor(Math.random() * RANCH_PREFIXES.length)]
      const ranchSuffix = RANCH_SUFFIXES[Math.floor(Math.random() * RANCH_SUFFIXES.length)]
      const ranchName = `${ranchPrefix} ${ranchSuffix}`
      
      const homeRegion = `region${Math.floor(Math.random() * 6) + 1}`
      
      const owner = new Owner(fullName, ranchName, homeRegion)
      
      // Give NPCs a reasonable starting budget based on their traits
      const baseMoney = 25000
      const traitBonus = (owner.shrewdness + owner.ambition + owner.competitiveness) / 300 // 0 to 1
      owner.money = Math.round(baseMoney * (1 + traitBonus))
      
      return owner
    }

    static generateInitialOwners(count = 40, playerRegion) {
      const owners = []
      const usedRanchNames = new Set()
      
      // Calculate number of nemesis owners (5% of total)
      const nemesisCount = Math.max(1, Math.floor(count * 0.05))
      
      // Create nemesis owners first
      for (let i = 0; i < nemesisCount; i++) {
        const nemesis = NemesisManager.createNemesisOwner(playerRegion)
        while (usedRanchNames.has(nemesis.ranchName)) {
          nemesis.ranchName = this.generateRandomRanchName()
        }
        owners.push(nemesis)
        usedRanchNames.add(nemesis.ranchName)
      }
  
      // Generate remaining owners
      for (let i = 0; i < count - nemesisCount; i++) {
        let owner = this.generateRandomOwner()
        
        while (usedRanchNames.has(owner.ranchName)) {
          owner.ranchName = this.generateRandomRanchName()
        }
        
        usedRanchNames.add(owner.ranchName)
        owners.push(owner)
      }
  
      return owners
    }
  
    static generateRandomRanchName() {
      const prefix = RANCH_PREFIXES[Math.floor(Math.random() * RANCH_PREFIXES.length)]
      const suffix = RANCH_SUFFIXES[Math.floor(Math.random() * RANCH_SUFFIXES.length)]
      return `${prefix} ${suffix}`
    }
}